export default __webpack_public_path__ + "static/media/Chat-Numbers-System-19.66f405d9.svg";